export const MESSAGING_ENABLED = 'enabled';
export const NOTIFICATION_PREFERENCE = 'notificationPreference';
export const SEND_MESSAGE_TO = 'formEmail';
export const WELCOME_MESSAGE = 'welcomeMessage';
export const FORM_SUCCESS_MESSAGE = 'formSuccessMessage';
export const EMAIL_OPT_IN_ENABLED = 'emailOptInEnabled';
export const EMAIL_OPT_IN_MESSAGE = 'emailOptInMessage';
export const REAMAZE_POSITION = 'reamazePosition';
export const REAMAZE_THEME_COLOR = 'reamazeThemeColor';
export const REAMAZE_PROMPT_ENABLED = 'reamazePromptEnabled';
export const REAMAZE_PROMPT = 'reamazePrompt';
export const REAMAZE_STARTER_1 = 'reamazeStarter1';
export const REAMAZE_STARTER_2 = 'reamazeStarter2';
export const REAMAZE_STARTER_3 = 'reamazeStarter3';
export const REAMAZE_STARTER_4 = 'reamazeStarter4';
export const REAMAZE_STARTER_5 = 'reamazeStarter5';
export const REAMAZE_EMBEDDABLE_SLUG = 'reamazeEmbeddableSlug';
export const REAMAZE_CONFIRMATION_MESSAGE = 'reamazeConfirmationMessage';
export const REAMAZE_AVATAR_IMAGE = 'reamazeAvatarImage';
export const REAMAZE_DISMISS_CAROUSEL = 'reamazeDismissCarousel';
export const REAMAZE_FAQ_ENABLED = 'reamazeFaqEnabled';
export const REAMAZE_ALLOW_BOT_PROCESSING = 'reamazeAllowBotProcessing';
